import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/styled-system';
import { rem } from '../../utils/utils';
import { ListColorsType } from './List';

const { defineMultiStyleConfig, definePartsStyle } = createMultiStyleConfigHelpers(['container', 'icon', 'item']);

type ColorsType = Record<ListColorsType, Record<'color' | 'backgroundColor', string>>;

const colors: ColorsType = {
  progress: {
    backgroundColor: 'sys/interactive/subtle',
    color: 'sys/interactive/strong',
  },
  neutral: {
    backgroundColor: 'sys/neutral/subtle',
    color: 'sys/neutral/strong',
  },
  info: {
    backgroundColor: 'sys/info/subtle',
    color: 'sys/info/strong',
  },
  positive: {
    backgroundColor: 'sys/success/subtle',
    color: 'sys/success/strong',
  },
  negative: {
    backgroundColor: 'sys/critical/subtle',
    color: 'sys/critical/strong',
  },
  warning: {
    backgroundColor: 'sys/warning/subtle',
    color: 'sys/warning/strong',
  },
  orange: {
    backgroundColor: 'sys/orange/subtle',
    color: 'sys/orange/strong',
  },
  turquoise: {
    backgroundColor: 'sys/turquoise/subtle',
    color: 'sys/turquoise/strong',
  },
};

const baseStyleContainer = defineStyle({
  marginInlineStart: '16',
});

const baseStyle = definePartsStyle({
  container: baseStyleContainer,
});

const variantOrdered = defineStyle((props) => {
  const { colorScheme } = props;
  return {
    container: {
      counterReset: 'count',
      marginInlineStart: rem(36),
    },
    item: {
      position: 'relative',
      counterIncrement: 'count',
      _before: {
        content: 'counter(count)',
        position: 'absolute',
        textAlign: 'center',
        textStyle: 'comp/badge/sm',
        borderRadius: '50%',
        left: `-${rem(36)}`,
        top: 0,
        paddingY: '4',
        width: '24',
        ...colors[(colorScheme as ListColorsType) || 'neutral'],
      },
    },
  };
});

const ListTheme = defineMultiStyleConfig({
  baseStyle,
  variants: {
    ordered: variantOrdered,
    unstyled: {
      container: {
        marginInlineStart: 0,
      },
    },
  },
});

export default ListTheme;
